import axios from 'axios';
import { ActionTypes as LoginActionTypes } from 'store/login/loginConstants';
import { showModal } from 'components/Modal/actions';
import { ModalStyle, ModalButtonStyle } from 'components/Modal';
import { translate } from 'utils/translateUtil';

// import {BASE_HEADER} from 'store/login/loginConstants';

const login = (alias: string, password: string) => {
	const ending = process.env.REACT_APP_API_CALL_ENDING ? process.env.REACT_APP_API_CALL_ENDING : '';
	let url = location.origin + location.pathname + 'olb_access_control/login' + ending;

	if(process.env.NODE_ENV === 'development'){
		url = location.origin + '/dummy/data/olb_access_control/login' + ending;
		// console.log('[loginActions/login] url:', url);
	}

	return (dispatch: any) => {
		// @ts-ignore
		const response = dispatch({
			type: LoginActionTypes.LOGIN,
			payload: axios({
				method: 'post',
				url,
				data: {
					alias,
					password
				}
			})
				.then(data => {
					return new Promise((resolve, reject) => {
						return resolve(data);
					});
				})
				.catch(err => {
					return new Promise((resolve, reject) => {
						return reject({ ...err, alias, password });
					});
				})
		});
	};
};

const resetPwd = (formValues: any) => {
	const ending = process.env.REACT_APP_API_CALL_ENDING ? process.env.REACT_APP_API_CALL_ENDING : '';

	let url = location.origin + location.pathname + 'olb_access_control/reset_password' + ending;
	let method = 'POST';

	if (process.env.NODE_ENV === 'development') {
		method = 'GET';
		url =
			location.origin + location.pathname + 'dummy/data/olb_access_control/reset_password' + ending;
	}

	return (dispatch: any) => {
		dispatch({
			type: LoginActionTypes.RESET_PASSWORD,
			payload: axios({
				method,
				url,
				data: {
					...formValues
				}
			})
				.then(data => {
					dispatch({ type: 'MODAL_SHOW' });
					return new Promise((resolve, reject) => {
						return resolve({ ...data });
					});
				})
				.catch(err => {
					dispatch({ type: 'MODAL_SHOW', options: { modalStyle: 'error' } });
					return new Promise((resolve, reject) => {
						return reject(err);
					});
				})
		});
	};
};

const firstLogin = (
	alias: string,
	oldPassword: string,
	newPassword: string,
	customerSignature: string // Data with the signature introduced by the customer (iTAN, mTAN, …) - if needed - example: 233412
) => {
	const ending = process.env.REACT_APP_API_CALL_ENDING ? process.env.REACT_APP_API_CALL_ENDING : '';
	let url = location.origin + location.pathname + 'olb_access_control/first_access/login' + ending;
	let method = 'POST';

	if (process.env.NODE_ENV === 'development') {
		method = 'GET';
		url =
			location.origin +
			location.pathname +
			'dummy/data/olb_access_control/first_access/login' +
			ending;
	}

	// console.log('[loginActions/firstLogin] alias:', alias, 'oldPassword:', oldPassword, 'newPassword:', newPassword, 'customerSignature:', customerSignature);

	return (dispatch: any) => {
		// @ts-ignore
		const response = dispatch({
			type: LoginActionTypes.FIRST_LOGIN,
			payload: axios({
				method,
				url,
				data: {
					alias,
					oldPassword,
					newPassword,
					customerSignature
				}
			})
				.then((data: any) => {
					return new Promise((resolve, reject) => {
						dispatch(
							showModal({
								modalStyle: ModalStyle.success,
								buttonStyle: ModalButtonStyle.confirm,

								textHeadline: translate('firstAccess.login.modal.headline.success'),
								textDescription: translate('firstAccess.login.modal.description.success'),
								textConfirm: translate('firstAccess.login.modal.cta.success'),

								onConfirm: () => {
									if (data && data.headers) {
										window.location.href = data.headers.location;
									}
								}
							})
						);

						return resolve(data);
					});
				})
				.catch(err => {
					return new Promise((resolve, reject) => {
						dispatch(
							showModal({
								modalStyle: ModalStyle.error,
								buttonStyle: ModalButtonStyle.confirm,

								textHeadline:
									err && err.problems && err.problems[0]
										? err.problems[0].title
										: translate('firstAccess.login.modal.headline.error'),
								textDescription:
									err && err.problems && err.problems[0]
										? err.problems[0].detail
										: translate('firstAccess.login.modal.description.error'),
								textConfirm: translate('firstAccess.login.modal.cta.error'),

								onConfirm: () => {
									window.location.href = window.location.href.replace(window.location.hash, '');
								}
							})
						);
						return reject({ ...err, loginData: { alias, oldPassword, newPassword } });
					});
				})
		});
	};
};

const doSecondFactor = (code: string, customerSignature: string) => {
	const url = location.origin + location.pathname + 'olb_access_control/2fa/transaction';
	// console.log('[loginActions/doSecondFactor] url:', url);

	return (dispatch: any) => {
		// @ts-ignore
		const response = dispatch({
			type: LoginActionTypes.DO_SECOND_FACTOR,
			payload: axios({
				method: 'post',
				url,
				data: {
					code,
					customerSignature
				}
			})
				.then(data => {
					return new Promise((resolve, reject) => {
						return resolve(data);
					});
				})
				.catch(err => {
					return new Promise((resolve, reject) => {
						return reject(err);
					});
				})
		});
	};
};

const onUnmountLoginComponent = () => {
	return {
		type: LoginActionTypes.UNMOUNT_LOGIN
	};
};

export { login, firstLogin, doSecondFactor, onUnmountLoginComponent, resetPwd };
